export let SenderAddress;
(function (_SenderAddress) {
  let Type = /*#__PURE__*/function (Type) {
    Type["CUSTOM"] = "custom";
    Type["PREZLYMAIL"] = "prezly_mail";
    return Type;
  }({});
  _SenderAddress.Type = Type;
})(SenderAddress || (SenderAddress = {}));